import {
    PROXY_DELIVERY_ORDER_LIST,
    UPDATE_PROXY_DELIVERY_ORDER_SEARCH_LIST,
    PROXY_DELIVERY_PACKAGE_ORDER_LIST,
    UPDATE_PROXY_DELIVERY_PACKAGE_ORDER_SEARCH_LIST,
    UPDATE_PROXY_DELIVERY_ORDER_CURRENT_PAGE_NUM,
    UPDATE_PROXY_DELIVERY_PACKAGE_SORT,
    SET_PROXY_DELIVERY_ORDER_SOURCE,
    UPDATE_PROXY_DELIVERY_ORDER_TAB_ACTIVE,
    VIEW_PROXY_DELIVERY_ORDER_PACKAGE,
    CLEARE_PROXY_DELIVERY_PACKAGE_DATA,
    UPDATE_PROXY_DELIVERY_ORDER_LIST_DATA,
    UPDATE_PROXY_DELIVERY_PACKAGE_LIST_DATA,
    UPDATE_VIEW_RECEIVE_PACKAGE_DATA,
    UPDATE_PROXY_DELIVERY_PACKAGE_RECEIVE_SEARCH_LIST,
    SYS_DICT,
    REJECT_PROXY_DELIVERY_PACKAGE,
    REJECT_REASON_SYS_DICT,
} from 'Actions/proxyDelivery';
import update from 'immutability-helper';
import {PROXY_DELIVERY_ORDER_PACKAGE_SORT} from 'Utils/constant';

let initialState = {
    proxyDeliveryOrderList: [],
    proxyDeliveryOrderListLoad: false,
    proxyDeliveryPackageOrderList: [],
    proxyDeliveryPackageOrderListLoad: false,
    proxyDeliveryPackageOrderSearchList: [],
    currentProxyDeliveryOrderPageNum: 0,
    proxyDeliveryPackageSort: PROXY_DELIVERY_ORDER_PACKAGE_SORT.ASC_SORT,
    fromProxyDeliveryOrderDetails: false,
    tabActive: 0,
    viewProxyDeliveryOrderPackageData: {},
    viewProxyDeliveryOrderTrackingData: {},
    statusOptions: [],
    rejectReasonList: [],
    rejectProxyDeliveryResult: {},

    proxyDeliveryOrderSearchfields: {
        queryKey: '',
    },

    proxyDeliveryPackageOrderSearchfields: {
        queryKey: '',
    },

    proxyDeliveryPackageReceiveSearchfields: {
        queryKey: '',
    },
};

export function proxyDelivery(state = initialState, action) {
    let payload = {};
    switch (action.type) {
        case PROXY_DELIVERY_ORDER_LIST:
            if (action.payload.pageNum <= 1) {
                payload.proxyDeliveryOrderList = action.payload.data;
            } else {
                payload.proxyDeliveryOrderList =
                    state.proxyDeliveryOrderList.concat(action.payload.data);
            }
            return {...state, ...payload};

        case UPDATE_PROXY_DELIVERY_ORDER_LIST_DATA:
            payload.proxyDeliveryOrderList = action.payload;
            return {...state, ...payload};

        case PROXY_DELIVERY_PACKAGE_ORDER_LIST:
            if (action.payload.pageNum <= 1) {
                payload.proxyDeliveryPackageOrderList = action.payload.data;
            } else {
                payload.proxyDeliveryPackageOrderList =
                    state.proxyDeliveryPackageOrderList.concat(
                        action.payload.data,
                    );
            }
            return {...state, ...payload};

        case UPDATE_PROXY_DELIVERY_PACKAGE_LIST_DATA:
            payload.proxyDeliveryPackageOrderList = action.payload;
            return {...state, ...payload};

        case SYS_DICT:
            payload.statusOptions = action.payload.data;
            return {...state, ...payload};

        case REJECT_REASON_SYS_DICT:
            payload.rejectReasonList = action.payload.data;
            return {...state, ...payload};

        case UPDATE_VIEW_RECEIVE_PACKAGE_DATA:
            payload.viewProxyDeliveryOrderPackageData = action.payload;
            return {...state, ...payload};

        case UPDATE_PROXY_DELIVERY_ORDER_SEARCH_LIST:
            payload.proxyDeliveryOrderSearchfields = action.payload;

            return {...state, ...payload};

        case UPDATE_PROXY_DELIVERY_PACKAGE_ORDER_SEARCH_LIST:
            payload.proxyDeliveryPackageOrderSearchfields = action.payload;

            return {...state, ...payload};

        case UPDATE_PROXY_DELIVERY_PACKAGE_RECEIVE_SEARCH_LIST:
            payload.proxyDeliveryPackageReceiveSearchfields = action.payload;

            return {...state, ...payload};

        case UPDATE_PROXY_DELIVERY_ORDER_CURRENT_PAGE_NUM:
            return update(state, {
                currentProxyDeliveryOrderPageNum: action.payload,
            });

        case UPDATE_PROXY_DELIVERY_PACKAGE_SORT:
            return update(state, {proxyDeliveryPackageSort: action.payload});

        case SET_PROXY_DELIVERY_ORDER_SOURCE:
            return update(state, {
                fromProxyDeliveryOrderDetails: action.payload,
            });

        case UPDATE_PROXY_DELIVERY_ORDER_TAB_ACTIVE:
            return update(state, {tabActive: action.payload});

        case VIEW_PROXY_DELIVERY_ORDER_PACKAGE:
            payload.viewProxyDeliveryOrderPackageData = action.payload;
            return {...state, ...payload};

        case CLEARE_PROXY_DELIVERY_PACKAGE_DATA:
            payload.viewProxyDeliveryOrderPackageData = {};
            return {...state, ...payload};
        case REJECT_PROXY_DELIVERY_PACKAGE:
            payload.rejectProxyDeliveryResult = action.payload;
            return {...state, ...payload};
        default:
            return state;
    }
}
